// Colocated strings for CategorySubcategoryList (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// Lifted verbatim from the app's `src/locales.js` (same names, top level) when the component
// moved into @rdrive/ui (2026-09-30).
//
// TRANSLATION TICKET — `noDataAvailable`: the empty-state text existed only in the `en`
// bundle there, so the other nine locales fell back to the English through `fallbackLocale`.
// It ships as ENGLISH in those nine files on purpose (the `loaded` policy): same rendering,
// no fallback warning, no chance of a blank. Replace a file's value as its translation lands.
// `vi` (the 11th locale, 2026-10-28) shipped translated.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
